import LoginView from "./LoginView";
export * from "./LoginView";
export default LoginView;